import { __awaiter } from '../../_virtual/_tslib.js';
import React__default, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Row from '../grid/row/Row.js';
import Col from '../grid/col/Col.js';
import Styles from './SelectRoutes.module.scss.js';
import { AppContext } from '../../app-context.js';
import AppCheckbox from '../app-checkbox/AppCheckbox.js';
import SearchField from '../search-field/SearchField.js';
import RouteState from '../route-state/RouteState.js';
import { STATE_LIST, STATE_ID_LIST } from '../../constants/StateList.js';
import AppBtn from '../app-btn/AppBtn.js';
import isEqual from 'lodash.isequal';
import usePrevious from '../../hooks/usePrevious.js';
import { IDs } from '../../constants/automation.js';

const SelectRoutes = ({ showHeader = true, routeIds, handleSelectedRoutes, isShowMoreVisible = false, areAllRoutesSelected = false, showMoreCount = 10, selectAllLabelText }) => {
    const { t } = useTranslation(["userProfile", "common"]);
    const { isMobile } = useContext(AppContext);
    const [stateList, setStateList] = useState(STATE_LIST);
    const [selectAllState, setSelectAllState] = useState(areAllRoutesSelected);
    const [selectedRouteIds, setSelectedRouteIds] = useState([]);
    const [seeMoreCount, setSeeMoreCount] = useState(isShowMoreVisible ? showMoreCount : STATE_LIST.length);
    const prevRouteIds = usePrevious(routeIds);
    useEffect(() => {
        if ((routeIds === null || routeIds === void 0 ? void 0 : routeIds.length) && !isEqual(prevRouteIds, routeIds)) {
            selectedRouteIds.length === STATE_LIST.length ? setSelectAllState(true) : setSelectAllState(false);
            const ids = routeIds.map((data) => data.id);
            setSelectedRouteIds(ids);
            handleSelectedRoutes === null || handleSelectedRoutes === void 0 ? void 0 : handleSelectedRoutes(ids);
        }
    }, [routeIds]);
    useEffect(() => {
        if (areAllRoutesSelected) {
            setSelectAllState(true);
        }
    }, [areAllRoutesSelected]);
    // Handle select state
    const onSelectState = (id) => __awaiter(void 0, void 0, void 0, function* () {
        setSelectAllState(false);
        if (!(selectedRouteIds === null || selectedRouteIds === void 0 ? void 0 : selectedRouteIds.includes(id))) {
            setSelectedRouteIds([...selectedRouteIds, id]);
            handleSelectedRoutes === null || handleSelectedRoutes === void 0 ? void 0 : handleSelectedRoutes([...selectedRouteIds, id]);
        }
        else {
            const index = selectedRouteIds.indexOf(id);
            if (index !== -1) {
                selectedRouteIds.splice(index, 1);
                setSelectedRouteIds([...selectedRouteIds]);
                handleSelectedRoutes === null || handleSelectedRoutes === void 0 ? void 0 : handleSelectedRoutes([...selectedRouteIds]);
            }
        }
    });
    // handle select all state
    const onClickSelectAll = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setSelectAllState(e);
        if (e) {
            setSelectedRouteIds([...STATE_ID_LIST]);
            handleSelectedRoutes === null || handleSelectedRoutes === void 0 ? void 0 : handleSelectedRoutes([...STATE_ID_LIST]);
        }
        else {
            setSelectedRouteIds([]);
            handleSelectedRoutes === null || handleSelectedRoutes === void 0 ? void 0 : handleSelectedRoutes([]);
        }
    });
    // Search filter for state
    const onSearchState = (e) => {
        const filteredList = STATE_LIST.filter((data) => data.name.toLowerCase().startsWith(e.target.value.toLowerCase()));
        filteredList.length ? setStateList(filteredList) : setStateList(STATE_LIST);
    };
    return (React__default.createElement("div", { className: Styles.container },
        showHeader && (React__default.createElement(Row, { className: Styles.routeCountSearchRow, noGutters: true },
            React__default.createElement(Col, { className: Styles.colCount },
                React__default.createElement("h4", null,
                    t("userProfile:form.my_routes_form.select_routes.routes_length_text"),
                    "(",
                    String(`0${selectedRouteIds.length}`).slice(-2),
                    ")")),
            React__default.createElement(Col, { className: Styles.colSearch },
                React__default.createElement(SearchField, { placeholder: t("userProfile:form.my_routes_form.select_routes.search_states"), onChange: (e) => onSearchState(e), searchWrapperClass: Styles.searchWrapper })))),
        React__default.createElement("div", { className: Styles.selectAllStateRow },
            React__default.createElement(AppCheckbox, { id: IDs.postingForm.selectAllState, labelText: selectAllLabelText
                    ? selectAllLabelText
                    : t("userProfile:form.my_routes_form.select_routes.select_all_states"), isChecked: selectAllState, onChange: onClickSelectAll, labelClass: Styles.checkBoxLabel, checkboxClass: Styles.checkBox, checkboxStyle: {
                    width: isMobile ? "22px" : "26px",
                    height: isMobile ? "22px" : "26px"
                }, styles: { width: "fit-content" } })),
        React__default.createElement("div", { className: Styles.routesBox },
            stateList.slice(0, seeMoreCount).map((data) => (React__default.createElement(React__default.Fragment, { key: data.id },
                React__default.createElement(RouteState, { routeValue: data.name, isSelect: selectedRouteIds.includes(data.id), onClickSelect: onSelectState, index: data.id })))),
            isShowMoreVisible && (React__default.createElement(AppBtn, { type: "link", onClick: () => setSeeMoreCount(seeMoreCount === showMoreCount ? STATE_LIST.length : showMoreCount), className: Styles.seeMoreBtn }, seeMoreCount === showMoreCount ? `See More` : `See Less`)))));
};

export { SelectRoutes };
//# sourceMappingURL=SelectRoutes.js.map
